import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {GET_COMPANY} from './graphql'
import {Query} from 'react-apollo'
import {CardHeader} from 'reactstrap'
import BlockWithLoader from '../Support/BlockWithLoader'
import CompanyForm from './CompanyForm'

const propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

class Company extends Component {
  render() {
    const paramsId = this.props.match.params.id
    const variables = paramsId === 'main' ? {main: true} : {id: paramsId}

    return (
      <Query query={GET_COMPANY} variables={variables} fetchPolicy='network-only'>
        {({data, loading, error}) => {
          if (error) {
            if (error.networkError && error.networkError.statusCode === 404) {
              return (<div>Not Found</div>)
            } else {
              return (<div>An unexpected error occurred</div>)
            }
          }

          return (
            <BlockWithLoader loading={loading} renderChildren={true}>
              <CardHeader><b>{`Company id: ${paramsId}`}</b></CardHeader>
              {!loading &&
              <CompanyForm company={data.company}
                afterSubmit={() => this.props.history.goBack() || this.props.history.push('/companies')}
                onClose={() => this.props.history.goBack() || this.props.history.push('/companies')}
              />
              }
            </BlockWithLoader>
          )
        }}
      </Query>
    )
  }
}

Company.propTypes = propTypes

export default Company



// WEBPACK FOOTER //
// ./src/components/Companies/Company.js